import { useEffect, useState } from "react";
import { resolveImageUrl } from "./common";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/opacity.css";
export const ImageWithDefault = ({ src, onerror, classList, id = "", ...props }) => {
  const [imgSrc, setImgSrc] = useState(src);
  useEffect(() => {
    setImgSrc(resolveImageUrl(src));
  }, [src]);
  const handleImageError = () => {
    if (onerror == null || onerror == "") {
      onerror = process.env.REACT_APP_NoImage;
    }
    setImgSrc(onerror);
  };

  return (
    <LazyLoadImage
      id={id}
      effect="opacity"
      wrapperProps={{
        style: { transitionDuration: "0.4s" },
      }}
      src={imgSrc}
      onError={handleImageError}
      data-original={src}
      className={classList}
      style={props.style}
      wrapperClassName={"img-center"}
      {...props}
    />
  );
};
